import produce from "immer";
import { IEntity, IStatusKey } from "./types";
import { clamp } from "./statsHelper";

type IApplyStatusExecutor = {
  [K in IStatusKey]: (draft: IEntity, turn: number) => void;
};

// warning: these functions will be used by a pure function(applyStatus)
// do NOT use them elsewhere

const poison = (draft: IEntity) => {
  const { hp } = draft.stats;
  hp.value -= 1;
  clamp(hp);
};

const blind = (draft: IEntity, relativeTurn: number) => {
  const { attack } = draft.stats;
  if (relativeTurn === 2 || relativeTurn === 4) attack.value = 0;
  else attack.value = attack.max;
};
const sleep = (draft: IEntity) => {
  const { attack, mpAttack } = draft.stats;
  attack.value = 0;
  mpAttack.value = 0;
};

const shell = (draft: IEntity) => {
  const { mpDefense } = draft.stats;
  mpDefense.value *= 2;
};

const protect = (draft: IEntity) => {
  const { defense } = draft.stats;
  defense.value *= 2;
};

export const statuses: IApplyStatusExecutor = {
  poison,
  blind,
  sleep,
  shell,
  protect
};

// eslint-disable-next-line max-lines-per-function
export const applyStatus = (
  actors: IEntity[],
  activeIndex: number,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  turn: number
): IEntity[] => {
  // eslint-disable-next-line max-lines-per-function
  return produce(actors, draft => {
    const actor = draft[activeIndex];

    // increase counter for all statuses
    actor.statuses.forEach(status => {
      status.start += 1;
    });

    // remove statuses that have ended
    actor.statuses
      .filter(status => status.start >= status.end)
      .forEach(status => {
        if (status.key === "sleep") {
          actor.stats.attack.value = actor.stats.attack.max;
          actor.stats.mpAttack.value = actor.stats.mpAttack.max;
        }
        if (status.key === "blind")
          actor.stats.attack.value = actor.stats.attack.max;
        if (status.key === "shell")
          actor.stats.mpDefense.value = actor.stats.mpDefense.max;
        if (status.key === "protect")
          actor.stats.defense.value = actor.stats.defense.max;
      });
    actor.statuses = actor.statuses.filter(status => status.start < status.end);

    // loop through active statuses (start >= 0)
    actor.statuses
      .filter(status => status.start >= 0)
      .forEach(status => {
        statuses[status.key](actor, status.start);
      });
  });
};
